import React, { useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import DummyOutput from './DummyOutput'
import { TabProvider } from '@tecuity/granite-ui/TabProvider'
import { TabPanel } from '@tecuity/granite-ui/TabPanel'
import { TabButton } from '@tecuity/granite-ui/TabButton'

const DummyUccDetails = () => {
  const [activeTabId, setActiveTabId] = useState('tab-0')
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)

  if (Object.keys(sourceTypeConfig).length === 0) return null
  return (
    <TabProvider activeTabId={activeTabId} onChange={setActiveTabId}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '20px' }}>
        <div className="row header-row space-between">
          <div className="center">
            <span style={{ fontWeight: 'bolder' }}>*</span> Field is visible based on logic in
            addition to this configuration.
          </div>
          <div className="tablist" role="tablist">
            <TabButton id={`tab-0`} forPanelId={`panel-0`} label={'General'} />
            <TabButton id={`tab-1`} forPanelId={`panel-1`} label={'Historical Details'} />
          </div>
        </div>
        <UCCRecordInfo />
        <TabPanel tabId={`tab-0`} id={`panel-0`}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <Submitter />
              <AuthorizingParty />
            </div>
            <DocumentInformation />
          </div>
          <InformationStatementDetail />
          <DebtorsAndSecuredParties />
          <LienCounties />
          <Collateral />
          <Miscellaneous />
          <EFSProducts />
          <VoidInfo />
          <OfficerCorrectionInfo />
          <DishonoredPaymentInfo />
        </TabPanel>
        <TabPanel tabId={`tab-1`} id={`panel-1`}>
          <HistoricalDetails />
        </TabPanel>
        <br />
      </div>
    </TabProvider>
  )
}

export default DummyUccDetails

const UCCRecordInfo = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="UCC Record Information" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DummyOutput
            accessor="UCCRecordType"
            info={sourceTypeConfig.UCCRecordType || {}}
            outputFormat="Type"
          />
          <DummyOutput
            accessor="LienType"
            info={sourceTypeConfig.LienType || {}}
            outputFormat="Type"
          />
          <DummyOutput
            accessor="UCCOtherType"
            info={sourceTypeConfig.UCCOtherType || {}}
            outputFormat="Other Type*"
          />
          <DummyOutput
            accessor="UCCAltDesignationType"
            info={sourceTypeConfig.UCCAltDesignationType || {}}
            outputFormat="Alt Type*"
          />
        </div>
        <div className="dummy-card-col">
          <DummyOutput
            accessor="Status"
            info={sourceTypeConfig.Status || {}}
            outputFormat="Approved"
          />
          <DummyOutput
            accessor="LapseDate"
            info={sourceTypeConfig.LapseDate || {}}
            outputFormat="MM/dd/yyyy"
          />
        </div>
      </div>
    </DetailCard>
  )
}

const Submitter = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Submitter" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DummyOutput
            accessor="ContactName"
            info={sourceTypeConfig.ContactName || {}}
            outputFormat="Full Name*"
          />
          <DummyOutput
            accessor="ContactPhone"
            info={sourceTypeConfig.ContactPhone || {}}
            outputFormat="(123)456-7890)*"
          />
          <DummyOutput
            accessor="ContactEmail"
            info={sourceTypeConfig.ContactEmail || {}}
            outputFormat="test@nowhere.not*"
          />
          <DummyOutput
            accessor="SubmitterNameAndAddress"
            info={sourceTypeConfig.SubmitterNameAndAddress || {}}
            outputFormat="Name and Address"
          />
        </div>
      </div>
    </DetailCard>
  )
}

const AuthorizingParty = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Authorizing Party" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DummyOutput
            accessor="AuthorizationPartyOrgName"
            info={sourceTypeConfig.AuthorizationPartyOrgName || {}}
            outputFormat="Org Name*"
          />
          <DummyOutput
            accessor="AuthorizationParty"
            info={sourceTypeConfig.AuthorizationParty || {}}
            outputFormat="Name and Address*"
          />
        </div>
      </div>
    </DetailCard>
  )
}

const DocumentInformation = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Document Information" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DummyOutput
            accessor="DocumentNumber"
            info={sourceTypeConfig.DocumentNumber || {}}
            outputFormat="U012345678"
          />
          <DummyOutput
            accessor="ReceivedDate"
            info={sourceTypeConfig.ReceivedDate || {}}
            outputFormat="MM/dd/yyyy"
          />
          <DummyOutput
            accessor="ProcessedDate"
            info={sourceTypeConfig.ProcessedDate || {}}
            outputFormat="MM/dd/yyyy"
          />
          {/* <DummyOutput
            accessor="LapseDate"
            info={sourceTypeConfig.LapseDate || {}}
            outputFormat="MM/dd/yyyy"
          /> */}
          <DummyOutput
            accessor="FilingChangeLapseDate"
            info={sourceTypeConfig.FilingChangeLapseDate || {}}
            outputFormat="MM/dd/yyyy*"
          />
          <DummyOutput
            accessor="Actions"
            info={sourceTypeConfig.Actions || {}}
            outputFormat="Filing Actions*"
          />
          {/* <DummyOutput
            accessor="Status"
            info={sourceTypeConfig.Status || {}}
            outputFormat="Approved"
          /> */}
          {/* <DummyOutput
            accessor="UCCRecordType"
            info={sourceTypeConfig.UCCRecordType || {}}
            outputFormat="Type"
          />
          <DummyOutput
            accessor="UCCType"
            info={sourceTypeConfig.UCCType || {}}
            outputFormat="Type"
          /> */}
          <DummyOutput accessor="Fees" info={sourceTypeConfig.Fees || {}} outputFormat="$1.95*" />{' '}
          <DummyOutput
            accessor="ReceiptNum"
            info={sourceTypeConfig.ReceiptNum || {}}
            outputFormat="000012345*"
          />
          <DummyOutput
            accessor="Amount"
            info={sourceTypeConfig.Amount || {}}
            outputFormat="$29.95*"
          />
          <DummyOutput
            accessor="ImageNum"
            info={sourceTypeConfig.ImageNum || {}}
            outputFormat="B1234-1234*"
          />
        </div>
      </div>
    </DetailCard>
  )
}

const InformationStatementDetail = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Information Statement" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DummyOutput
            accessor="ClaimStatement"
            info={sourceTypeConfig.ClaimStatement || {}}
            outputFormat="String"
          />
        </div>
      </div>
    </DetailCard>
  )
}

const LienCounties = () => {
  const { recordDetailConfig } = useSelector((state) => state.settings, shallowEqual);
  
  return recordDetailConfig && recordDetailConfig.sourceTypeConfig && recordDetailConfig.sourceTypeConfig.CountyName
    ? (
      <DetailCard className="detailsCard" label="Counties" style={{ flexGrow: '1' }}>
        <div className="dummy-card">
          <div className="dummy-card-col">
            <DetailCard className='sub-card' label="County 1" customCss={{ width: '100%' }}>
              <DummyOutput
                accessor="CountyName"
                info={recordDetailConfig.sourceTypeConfig.CountyName}
                outputFormat="Name*"
              />
            </DetailCard>
          </div>
        </div>
      </DetailCard>
    )
    : null;
};


const DebtorsAndSecuredParties = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard
      className="detailsCard"
      label="Debtors and Secured Parties"
      style={{ flexGrow: '1' }}
    >
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DetailCard
            className='sub-card'
            label={`Debtor/Secured Party 1`}
            customCss={{ width: '100%' }}
          >
            <DummyOutput
              accessor="PartyName"
              info={sourceTypeConfig.PartyName || {}}
              outputFormat="Name*"
            />
            <DummyOutput
              accessor="PartyType"
              info={sourceTypeConfig.PartyType || {}}
              outputFormat="Type*"
            />
            <DummyOutput
              accessor="PartyUIN"
              info={sourceTypeConfig.PartyUIN || {}}
              outputFormat="UIN*"
            />
            <DummyOutput
              accessor="TinNumber"
              info={sourceTypeConfig.TinNumber || {}}
              outputFormat="TIN*"
            />
            <DummyOutput
              accessor="PartyAddress"
              info={sourceTypeConfig.PartyAddress || {}}
              outputFormat="Address*"
            />
            <DummyOutput
              accessor="PartyIsAssignee"
              info={sourceTypeConfig.PartyIsAssignee || {}}
              outputFormat="string*"
            />
          </DetailCard>
        </div>
      </div>
    </DetailCard>
  )
}

const Collateral = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Collateral" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DummyOutput
            accessor="UCCCollateral"
            info={sourceTypeConfig.UCCCollateral || {}}
            outputFormat="Description"
          />
          <DummyOutput
            accessor="UCCCollateralType"
            info={sourceTypeConfig.UCCCollateralType || {}}
            outputFormat="Type*"
          />
        </div>
      </div>
    </DetailCard>
  )
}

const Miscellaneous = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Miscellaneous" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          {/* <DummyOutput
            accessor="UCCType"
            info={sourceTypeConfig.UCCType || {}}
            outputFormat="Type"
          /> */}
          <DummyOutput
            accessor="FilerReference"
            info={sourceTypeConfig.FilerReference || {}}
            outputFormat="123456789*"
          />
          <DummyOutput
            accessor="LegacyReceiptNumber"
            info={sourceTypeConfig.LegacyReceiptNumber || {}}
            outputFormat="012345678*"
          />
          <DummyOutput
            accessor="LegacyRollNumber"
            info={sourceTypeConfig.LegacyRollNumber || {}}
            outputFormat="Y-1234567*"
          />
          <DummyOutput
            accessor="AddendumSerialNumber"
            info={sourceTypeConfig.AddendumSerialNumber || {}}
            outputFormat="01234567*"
          />
          <DummyOutput
            accessor="MiscellaneousAddendum"
            info={sourceTypeConfig.MiscellaneousAddendum || {}}
            outputFormat="String*"
          />
          <DummyOutput
            accessor="MiscInfo"
            info={sourceTypeConfig.MiscInfo || {}}
            outputFormat="Misc Info*"
          />
          <DummyOutput
            accessor="CoversTimber"
            info={sourceTypeConfig.CoversTimber || {}}
            outputFormat="Yes/No*"
          />
          <DummyOutput
            accessor="CoversExtracted"
            info={sourceTypeConfig.CoversExtracted || {}}
            outputFormat="Yes/No*"
          />
          <DummyOutput
            accessor="IsFixtureFiling"
            info={sourceTypeConfig.IsFixtureFiling || {}}
            outputFormat="Yes/No*"
          />
          <DummyOutput
            accessor="FileInRealEstate"
            info={sourceTypeConfig.FileInRealEstate || {}}
            outputFormat="Yes/No*"
          />
          <DummyOutput
            accessor="RealEstateOwnerAddress"
            info={sourceTypeConfig.RealEstateOwnerAddress || {}}
            outputFormat="String*"
          />
          <DummyOutput
            accessor="RealEstateDescription"
            info={sourceTypeConfig.RealEstateDescription || {}}
            outputFormat="String*"
          />
        </div>
      </div>
    </DetailCard>
  )
}

const EFSProducts = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="EFS Information" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DetailCard
            className='sub-card'
            label={`Product 1`}
            customCss={{ width: '100%' }}
          >
            <DummyOutput
              accessor="ProductType"
              info={sourceTypeConfig.ProductType || {}}
              outputFormat="String"
            />
            <DummyOutput
              accessor="ProductCounty"
              info={sourceTypeConfig.ProductCounty || {}}
              outputFormat="String"
            />
            <DummyOutput
              accessor="ProductYear"
              info={sourceTypeConfig.ProductYear || {}}
              outputFormat="String"
            />
            {sourceTypeConfig.ProductEndYear && (
              <DummyOutput
                accessor="ProductEndYear"
                info={sourceTypeConfig.ProductEndYear}
                outputFormat="String"
              />
            )}
            <DummyOutput
              accessor="ProductDescription"
              info={sourceTypeConfig.ProductDescription || {}}
              outputFormat="String"
            />
          </DetailCard>
        </div>
      </div>
    </DetailCard>
  )
}

const VoidInfo = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Void Information" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DummyOutput
            accessor="VoidReason"
            info={sourceTypeConfig.VoidReason || {}}
            outputFormat="Reason for Void"
          />
        </div>
      </div>
    </DetailCard>
  )
}

const OfficerCorrectionInfo = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Officer Correction" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DetailCard
            className='sub-card'
            label={`Correction 1`}
            customCss={{ width: '100%' }}
          >
            <DummyOutput
              accessor="OfficerCorrectionInfoDLN"
              info={sourceTypeConfig.OfficerCorrectionInfoDLN || {}}
              outputFormat="B1234-1234"
            />
          </DetailCard>
        </div>
      </div>
    </DetailCard>
  )
}

const DishonoredPaymentInfo = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)
  return (
    <DetailCard className="detailsCard" label="Dishonored Payment" style={{ flexGrow: '1' }}>
      <div className="dummy-card">
        <div className="dummy-card-col">
          <DetailCard
            className='sub-card'
            label={`Dishonored Payment 1`}
            customCss={{ width: '100%' }}
          >
            <DummyOutput
              accessor="PaymentDelinquentInfoDLN"
              info={sourceTypeConfig.PaymentDelinquentInfoDLN || {}}
              outputFormat="B1234-1234"
            />
            <DummyOutput
              accessor="PaymentDelinquentInfoReason"
              info={sourceTypeConfig.PaymentDelinquentInfoReason || {}}
              outputFormat="Reason"
            />
          </DetailCard>
        </div>
      </div>
    </DetailCard>
  )
}

const HistoricalDetails = () => {
  const {
    recordDetailConfig: { sourceTypeConfig },
  } = useSelector((state) => state.settings, shallowEqual)

  return (
    <div>
      <DetailCard className="detailsCard" label="Debtor Details" style={{ flexGrow: '1' }}>
        <div className="dummy-card">
          <div className="dummy-card-col">
            <DetailCard
              className='sub-card'
              label={`Debtor Row`}
              customCss={{ width: '100%' }}
            >
              <DummyOutput
                accessor="HistoricalDebtorName"
                info={sourceTypeConfig.HistoricalDebtorName || {}}
                outputFormat="String"
              />
              <DummyOutput
                accessor="HistoricalDebtorAddress"
                info={sourceTypeConfig.HistoricalDebtorAddress || {}}
                outputFormat="Address"
              />
              <DummyOutput
                accessor="HistoricalActionTaken"
                info={sourceTypeConfig.HistoricalActionTaken || {}}
                outputFormat="String"
              />
              <DummyOutput
                accessor="HistoricalActionDate"
                info={sourceTypeConfig.HistoricalActionDate || {}}
                outputFormat="MM/dd/yyyy"
              />
              <DummyOutput
                accessor="HistoricalIsCurrent"
                info={sourceTypeConfig.HistoricalIsCurrent || {}}
                outputFormat="String"
              />
            </DetailCard>
          </div>
        </div>
      </DetailCard>
      <DetailCard className="detailsCard" label="Secured Party Details" style={{ flexGrow: '1' }}>
        <div className="dummy-card">
          <div className="dummy-card-col">
            <DetailCard
              className="sub-card"
              label={`Secured Party Row`}
              customCss={{ width: '100%' }}
            >
              <DummyOutput
                accessor="HistoricalSecuredPartyName"
                info={sourceTypeConfig.HistoricalSecuredPartyName || {}}
                outputFormat="String"
              />
              <DummyOutput
                accessor="HistoricalSecuredPartyAddress"
                info={sourceTypeConfig.HistoricalSecuredPartyAddress || {}}
                outputFormat="Address"
              />
              <DummyOutput
                accessor="HistoricalActionTaken"
                info={sourceTypeConfig.HistoricalActionTaken || {}}
                outputFormat="String"
              />
              <DummyOutput
                accessor="HistoricalActionDate"
                info={sourceTypeConfig.HistoricalActionDate || {}}
                outputFormat="MM/dd/yyyy"
              />
              <DummyOutput
                accessor="HistoricalIsCurrent"
                info={sourceTypeConfig.HistoricalIsCurrent || {}}
                outputFormat="String"
              />
            </DetailCard>
          </div>
        </div>
      </DetailCard>
    </div>
  )
}

// {
//   "FilingNum": {
//       "Enabled": true,
//       "DisplayName": "Financing Statement Doc #"
//   },
//   "ReceivedDate": {
//       "Enabled": true,
//       "DisplayName": "Initial Filing Date"
//   },
//   "LapseDate": {
//       "Enabled": true,
//       "DisplayName": "Lapse Date"
//   },
//   "ContactName": {
//       "Enabled": true,
//       "DisplayName": "Contact Name"
//   },
//   "ContactPhone": {
//       "Enabled": true,
//       "DisplayName": "Contact Phone"
//   },
//   "ContactEmail": {
//       "Enabled": true,
//       "DisplayName": "Contact Email"
//   },
//   "SubmitterNameAndAddress": {
//       "Enabled": true,
//       "DisplayName": "Send Acknowledgment To"
//   },
//   "DocumentNumber": {
//       "Enabled": true,
//       "DisplayName": "Doc #"
//   },
//   "DocumentDate": {
//       "Enabled": true,
//       "DisplayName": "Date"
//   },
//   "Actions": {
//       "Enabled": true,
//       "DisplayName": "Amendment Actions"
//   },
//   "Status": {
//       "Enabled": true,
//       "DisplayName": "Doc State"
//   },
//   "UCCRecordType": {
//       "Enabled": true,
//       "DisplayName": "Record Type"
//   },
//   "UCCType": {
//       "Enabled": true,
//       "DisplayName": "Filing Type"
//   },
//   "Fees": {
//       "Enabled": true,
//       "DisplayName": "Fees"
//   },
//   "ReceiptNum": {
//       "Enabled": true,
//       "DisplayName": "Receipt #"
//   },
//   "Amount": {
//       "Enabled": true,
//       "DisplayName": "Receipt Amount"
//   },
//   "ImageNum": {
//       "Enabled": true,
//       "DisplayName": "DLN"
//   },
//   "AuthorizationParty": null,
//   "UCCOtherType": {
//       "Enabled": true,
//       "DisplayName": "Filing Type Other"
//   },
//   "FilerReference": {
//       "Enabled": true,
//       "DisplayName": "Optional Filer Ref Data"
//   },
//   "UCCCollateral": {
//       "Enabled": true,
//       "DisplayName": "Description"
//   },
//   "RecordDetailHistorySettings": {
//       "Type": {
//           "Enabled": true,
//           "DisplayName": "Type"
//       },
//       "Number": {
//           "Enabled": true,
//           "DisplayName": "Num"
//       },
//       "ReceivedDate": null,
//       "DocNumber": {
//           "Enabled": true,
//           "DisplayName": "DLN"
//       },
//       "ReceiptNumber": {
//           "Enabled": true,
//           "DisplayName": "Receipt Num"
//       },
//       "ReceiptAmount": {
//           "Enabled": true,
//           "DisplayName": "Amount"
//       },
//       "Status": {
//           "Enabled": true,
//           "DisplayName": "Status"
//       },
//       "Submitter": {
//           "Enabled": true,
//           "DisplayName": "Submitter"
//       },
//       "LastModifiedBy": {
//           "Enabled": true,
//           "DisplayName": "Last Modified By"
//       },
//       "Void": {
//           "Enabled": true,
//           "DisplayName": "Void"
//       },
//       "Correspondence": {
//           "Enabled": true,
//           "DisplayName": "Correspondence Download(s)"
//       }
//   }
// }
